import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import searchFilter from '../../searchFilter';
import {CartStateContext} from '../../contexts/cart';
import ShoppingBag03Svg from '../../assets/icons0/shopping-bag-03.svg';
import Browser from '../Browser';
import classNames from 'classnames';

const ShoppingBag = ({menuFlag}) => {
    const location = useLocation();
    const state = React.useContext(CartStateContext);
    const quantity = React.useMemo(() => state.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0), [state]);
    return (
        <Link 
            to={`/checkout/cart${searchFilter(location.search)}`} 
            className={classNames({'visibility-hidden': menuFlag, 'mw768-visibility-visible': true})}
        >
            <div className='height-2dot5rem width-2dot5rem display-flex justify-content-center align-items-center position-relative'>
                <ShoppingBag03Svg className='display-block height-1dot5rem width-1dot5rem color-gray-600'/>
                {!!quantity &&
                    <Browser>
                        <div className='position-absolute color-white background-color-gray-600 border-radius-50percent text-xs medium text-align-center' style={{top: 2, left: 20, width: '18px', height: '18px'}}>{quantity}</div>
                    </Browser>
                }
            </div>
        </Link>
    );
};

export default React.memo(ShoppingBag);